import { Alert } from '@mui/material'
import { FC } from 'react'
import { useRecordContext, useTranslate } from 'react-admin'
import { CertificateOut } from '../../types/apiRequests'
import { border } from '../../layout/theme/border'
import { daysUntilExpiry, expiryTone, formatExpiry } from './CertificatePills'

// Calm inline banner: rounded, no shadow, sits inside the "next step" card.
const alertSx = { borderRadius: `${border.radius.md}px`, alignItems: 'center' } as const

const ExpiryAlert: FC = () => {
  const record = useRecordContext<CertificateOut>()
  const translate = useTranslate()
  const daysUntil = daysUntilExpiry(record)
  if (daysUntil === null) return null

  const dateStr = formatExpiry(record)
  const tone = expiryTone(daysUntil)

  if (tone === 'error') {
    return (
      <Alert severity="error" variant="outlined" sx={alertSx}>
        {translate('resources.certificates.alerts.expired', {
          date: dateStr,
          _: `Certificaat is verlopen op ${dateStr}`,
        })}
      </Alert>
    )
  }

  if (tone === 'warning') {
    return (
      <Alert severity="warning" variant="outlined" sx={alertSx}>
        {translate('resources.certificates.alerts.expiresSoon', {
          date: dateStr,
          days: daysUntil,
          _: `Certificaat verloopt op ${dateStr}`,
        })}
      </Alert>
    )
  }

  return (
    <Alert severity="info" variant="outlined" sx={alertSx}>
      {translate('resources.certificates.alerts.expiresOn', {
        date: dateStr,
        _: `Certificaat verloopt op ${dateStr}`,
      })}
    </Alert>
  )
}

export default ExpiryAlert
